module.exports = __webpack_public_path__ + "static/media/全国“名特优新”个体工商户培育平台-操作手册.9efa3da0.pdf";